export const TEST_ID = 'statItem';
